import { CSSProperties } from 'react';
import * as S from './styles';

type Props = {
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export function LoadingSpinner({
  size = 16,
  color = 'var(--primary)',
  style
}: Props) {
  return (
    <S.Wrapper size={size} color={color} style={style}>
      <div></div><div></div><div></div><div></div>
    </S.Wrapper>
  )
}